var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.7338V9.26718C1.66602 8.40052 2.37435 7.68385 3.24935 7.68385C4.75768 7.68385 5.37435 6.61718 4.61602 5.30885C4.18268 4.55885 4.44102 3.58385 5.19935 3.15052L6.64102 2.32552C7.29935 1.93385 8.14935 2.16718 8.54102 2.82552L8.63268 2.98385C9.38268 4.29218 10.616 4.29218 11.3743 2.98385L11.466 2.82552C11.8577 2.16718 12.7077 1.93385 13.366 2.32552L14.8077 3.15052C15.566 3.58385 15.8243 4.55885 15.391 5.30885C14.6327 6.61718 15.2493 7.68385 16.7577 7.68385C17.6243 7.68385 18.341 8.39218 18.341 9.26718V10.7338C18.341 11.6005 17.6327 12.3172 16.7577 12.3172C15.2493 12.3172 14.6327 13.3838 15.391 14.6922C15.8243 15.4505 15.566 16.4172 14.8077 16.8505L13.366 17.6755C12.7077 18.0672 11.8577 17.8339 11.466 17.1755L11.3743 17.0172C10.6243 15.7089 9.39102 15.7089 8.63268 17.0172L8.54102 17.1755C8.14935 17.8339 7.29935 18.0672 6.64102 17.6755L5.19935 16.8505C4.44102 16.4172 4.18268 15.4422 4.61602 14.6922C5.37435 13.3838 4.75768 12.3172 3.24935 12.3172C2.37435 12.3172 1.66602 11.6005 1.66602 10.7338Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a45b04fea3488d9535309df0434c5813.svg";
export { ForwardRef as ReactComponent };